import React from 'react';
import HeroSection from '../components/home/HeroSection';
import FeaturedUniversities from '../components/home/FeaturedUniversities';
import ServicesOverview from '../components/home/ServicesOverview';
import WhyChooseUs from '../components/home/WhyChooseUs';
import TestimonialsSection from '../components/home/TestimonialsSection';
import NewsSection from '../components/home/NewsSection';
import ContactCTA from '../components/home/ContactCTA';
import { useSEO } from '../hooks/useSEO';

const Home = () => {
  // 设置首页 SEO
  useSEO('home');

  return (
    <>
      <HeroSection />
      <FeaturedUniversities />
      <ServicesOverview />
      <WhyChooseUs />
      <TestimonialsSection />
      <NewsSection />
      <ContactCTA />
    </>
  );
};

export default Home;
